import axiosInstance from "./axios-instance";
import { isMutationSuccess } from "./cache-utils";
import { invalidateProjectDataCache, resolveClientId } from "./cache-invalidation";

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === "undefined") {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem("accountId") || "0");
};

const withScopedAccountId = (payload: any) => {
  if (!payload || typeof payload !== "object") {
    return payload;
  }

  const scopedAccountId = getScopedAccountId((payload as any).accountId);
  if (scopedAccountId > 0) {
    return {
      ...payload,
      accountId: scopedAccountId,
    };
  }

  return payload;
};

const withScopedQueryParams = (params: any) => {
  if (!params || typeof params !== "object") {
    return params;
  }

  const scopedAccountId = getScopedAccountId((params as any).accountId);
  if (scopedAccountId > 0) {
    return {
      ...params,
      accountId: scopedAccountId,
    };
  }

  return params;
};

export const createPurchasedGoods = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/purchased-goods/create`, withScopedAccountId(payload))
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data))
    }

    return response.data
  } catch (error) {
    console.error(error)
    return
  }
}

export const updatePurchasedGoods = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/purchased-goods/update`, withScopedAccountId(payload))
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data))
    }

    return response.data
  } catch (error) {
    console.error(error)
    return
  }
}

export const getPurchasedGoods = async (params: any) => {
  try {
    const response = await axiosInstance.get(`/purchased-goods/get-all`, {
      params: withScopedQueryParams(params)
    })

    return response.data
  } catch (error) {
    console.error(error)
    return
  }
}

export const deletePurchasedGoods = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/purchased-goods/delete`, withScopedAccountId(payload))
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data))
    }

    return response.data
  } catch (error) {
    console.error(error)
    return
  }
}

export const getSinglePurchasedGood = async (id: any, accountId?: number) => {
  try {
    const scopedAccountId = getScopedAccountId(accountId);
    const accountIdQuery = scopedAccountId > 0 ? `?accountId=${scopedAccountId}` : "";
    const response = await axiosInstance.get(`/purchased-goods/${id}${accountIdQuery}`)

    return response.data
  } catch (error) {
    console.error(error)
    return
  }
}

export const duplicatePurchasedGood = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/purchased-goods/duplicate`, withScopedAccountId(payload))
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data))
    }

    return response.data
  } catch (error) {
    console.error(error)
    return
  }
}

export const componentUpdatePurchasedGood = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/purchased-goods/component-update`, withScopedAccountId(payload))
    if (isMutationSuccess(response.data)) {
      invalidateProjectDataCache(resolveClientId(payload, response.data))
    }

    return response.data
  } catch (error) {
    console.error(error)
    return
  }
}
